module.exports = __webpack_public_path__ + "img/duration.1ea791cc.svg";